// Compteur de crédits toujours visible (rail sur ordinateur, en-tête sur téléphone). Règles pures, testées à part.
import type { Sale } from "../types";

export type CreditLevel = "ok" | "low" | "empty";

/**
 * Niveau du solde disponible (solde moins crédits retenus) : bas dès qu'une recherche de mobile, la plus chère par
 * personne, ne passe plus ; vide à zéro.
 */
export const creditLevel = (
  available: number,
  mobilePrice: number,
): CreditLevel =>
  available <= 0 ? "empty" : available < mobilePrice ? "low" : "ok";

/** Nombre court pour le rail (72 px) : entier jusqu'à 9 999, en milliers au-delà. */
export const shortCount = (count: number, locale: string) =>
  new Intl.NumberFormat(
    locale,
    count >= 10_000 ? { notation: "compact", maximumFractionDigits: 0 } : {},
  ).format(count);

/** L'invité ne lance aucune recherche de contacts : un « 0 » permanent passerait pour une panne. */
export const seesCreditGauge = (
  sale:
    | Pick<Sale, "partner" | "administrator" | "partner_offer">
    | undefined
    | null,
) =>
  !!sale &&
  (!sale.partner || sale.administrator || sale.partner_offer === "subscriber");
